import { useCallback, useMemo } from "react"
import { useParams } from "react-router-dom"
import { useApplicationRolePermissions } from "../../../../../../hooks/useApplicationRolePermissions"
import { useDeleteConfirm } from "../../../../../../hooks/useDeleteConfirm"
import { ApplicationRolePermissionDetailGet } from "../../../../../models/ApplicationRolePermission"
import { DimaFeatureShortNameEnum } from "../../../../../models/Authorization"
import { deleteEntity } from "../../../../../utils/deleteEntity"
import { booleanComparator, getDoneIcon, getEmptyIcon } from "../../../../../utils/getBooleanFlagIcon"
import { DiMaAddButton } from "../../../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../../../partials/EntityTab"

export function ApplicationRolePermissions() {
  const { applicationId, roleId } = useParams()
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()
  const { applicationRolePermissions, isLoadingApplicationRolePermissions } =
    useApplicationRolePermissions(applicationId, roleId)

  const columns = [
    {
      field: "name",
      headerName: "Name",
      isLink: true,
      linkBasePath: `/applications/${applicationId}/roles/${roleId}/permissions`,
    },
    {
      field: "hasProperties",
      headerName: "Has properties",
      renderCell: (row: EntityRow) => row.hasProperties ? getDoneIcon() : getEmptyIcon(),
      sortComparator: booleanComparator,
    },
  ]

  const sorted = [...applicationRolePermissions].sort((a, b) =>
    (a.permission?.name ?? "").localeCompare(b.permission?.name ?? "")
  )

  const rows = sorted.map((permission: ApplicationRolePermissionDetailGet) => ({
    id: permission.permission.id,
    name: permission.permission.name,
    hasProperties: permission.properties.length > 0,
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url={`/applications/${applicationId}/roles/${roleId}/permissions/create`}
        feature={DimaFeatureShortNameEnum.AM}
      />
    ),
    [applicationId, roleId]
  )

  const handleActionMenuClick = useCallback((item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() =>
          deleteEntity(
            `/applications/${applicationId}/roles/${roleId}/permissions/${row.id}`
          )
        )
      }
    }, [applicationId, roleId, requestDelete])

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={columns}
        isLoading={isLoadingApplicationRolePermissions}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
